export default "__VITE_ASSET__DQEI9oZV__"